import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function Layout({ children, hideFooter = false }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
